import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import type Announcement from '../models/announcement';
import MessageCard from './message-card.component';
import EditAnnouncementModal from '../modals/edit-announcement-modal.component';
import { announcementStatus, progressPercentage, windowLabel } from '../message-status';

interface Props {
  readonly initialAnnouncement: Announcement;
  readonly handleUpdateAnnouncement: (originalAnnouncement: Announcement, changedAnnouncement: Announcement) => Promise<boolean>;
  readonly announcementIsValid: (value: Announcement) => boolean;
  readonly onDelete: (value: Announcement) => Promise<boolean>;
}

const AnnouncementCard = ({
  initialAnnouncement,
  handleUpdateAnnouncement: handleChange,
  announcementIsValid,
  onDelete,
}: Props): React.JSX.Element => {
  const [showAnnouncementModal, setShowAnnouncementModal] = useState(false);

  const { t } = useTranslation();
  const translate = (key: string): string => t(key) ?? '';

  const status = announcementStatus(initialAnnouncement.startDate, initialAnnouncement.endDate);

  return (
    <>
      <MessageCard
        status={status}
        title={initialAnnouncement.message}
        when={windowLabel(status, initialAnnouncement.startDate, initialAnnouncement.endDate, translate)}
        tagLabel={initialAnnouncement.isNonWorkingDay ? translate('non-working-day') : undefined}
        progress={status === 'active' ? progressPercentage(initialAnnouncement.startDate, initialAnnouncement.endDate) : undefined}
        onOpen={(): void => {
          setShowAnnouncementModal(true);
        }}
      />
      <EditAnnouncementModal
        showModal={showAnnouncementModal}
        initialAnnouncement={initialAnnouncement}
        handleSave={handleChange}
        onDelete={onDelete}
        handleClose={(): void => {
          setShowAnnouncementModal(false);
        }}
        announcementIsValid={announcementIsValid}
      />
    </>
  );
};

export default AnnouncementCard;
